<div class="invoice-container">
  <h2>Sales Invoices</h2>

  <div class="actions-section" hidden>
    <button mat-raised-button class="create-btn" (click)="createNewInvoice()">
      <mat-icon>add</mat-icon>
      Create New Invoice
    </button>
  </div>
  
  <div class="invoice-content">
    <div *ngIf="loading" class="loading-message">
      <p>Loading invoices...</p>
    </div>

    <div *ngIf="error" class="error-message">
      <p>{{ error }}</p>
      <button mat-raised-button color="primary" (click)="loadInvoices()">Retry</button>
    </div>

    <div *ngIf="!loading && !error" class="table-container">
      <!-- Search Filter -->
      <mat-form-field class="filter-field">
        <mat-label>Search invoices</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="Search by invoice number, customer..." #input>
        <mat-icon matSuffix>search</mat-icon>
      </mat-form-field>

      <!-- Invoices Table -->
      <table mat-table [dataSource]="dataSource" matSort class="invoice-table">
        
        <!-- Invoice Number Column -->
        <ng-container matColumnDef="invoiceNumber">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Invoice #</th>
          <td mat-cell *matCellDef="let invoice">{{ invoice.invoiceNumber || '-' }}</td>
        </ng-container>

        <!-- Invoice Date Column -->
        <ng-container matColumnDef="invoiceDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Invoice Date</th>
          <td mat-cell *matCellDef="let invoice">{{ invoice.invoiceDate ? (invoice.invoiceDate | date:'MM/dd/yyyy') : '-' }}</td>
        </ng-container>

        <!-- Due Date Column -->
        <ng-container matColumnDef="dueDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Due Date</th>
          <td mat-cell *matCellDef="let invoice">{{ invoice.dueDate ? (invoice.dueDate | date:'MM/dd/yyyy') : '-' }}</td>
        </ng-container>

        <!-- Ship Date Column -->
        <ng-container matColumnDef="shipDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Ship Date</th>
          <td mat-cell *matCellDef="let invoice">{{ invoice.shipDate ? (invoice.shipDate | date:'MM/dd/yyyy') : '-' }}</td>
        </ng-container>

        <!-- Customer Name Column -->
        <ng-container matColumnDef="customerName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Customer</th>
          <td mat-cell *matCellDef="let invoice">{{ invoice.customerName || '-' }}</td>
        </ng-container>

        <!-- Total Amount Column -->
        <ng-container matColumnDef="totalAmount">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Total Amount</th>
          <td mat-cell *matCellDef="let invoice">{{ invoice.totalAmount | currency }}</td>
        </ng-container> 
        
        <!-- Amount Paid Column -->
        <ng-container matColumnDef="amountPaid">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Amount Paid</th>
          <td mat-cell *matCellDef="let invoice">{{ invoice.amountPaid | currency }}</td>
        </ng-container>

        <!-- Status Column -->
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
          <td mat-cell *matCellDef="let invoice">
            <span class="status-badge" 
                  [class.status-paid]="invoice.status === 'Paid'"
                  [class.status-overdue]="invoice.status === 'Overdue'"
                  [class.status-pending]="invoice.status === 'Sent' || invoice.status === 'PartiallyPaid'">
              {{ (invoice.status || 'Draft') | humanizeEnum }}
            </span>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="table-row clickable-row" (click)="editInvoice(row)"></tr>

        <!-- No Data Row -->
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell no-data" [attr.colspan]="displayedColumns.length">
            <div class="no-invoices">
              <mat-icon>receipt</mat-icon>
              <p *ngIf="!input.value">No invoices found. Click "Create New Invoice" to add your first invoice.</p>
              <p *ngIf="input.value">No invoices match "{{ input.value }}"</p>
            </div>
          </td>
        </tr>
      </table>

      <!-- Paginator -->
      <mat-paginator 
        [pageSizeOptions]="[5, 10, 25, 50]" 
        [pageSize]="10"
        showFirstLastButtons
        aria-label="Select page of invoices">
      </mat-paginator>
    </div>
  </div>
</div>
